import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useDispatch} from "react-redux";
import {changeContract} from "../contractSlice";

export default function RoyaltiesTabs() {
    const [value, setValue] = React.useState(0);

    const dispatchData = useDispatch();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue == 0) {
            dispatchData(changeContract({contractGridVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: false, module: 'Royalties',contractGridAPI: "RoyalStandards"}));

        }
        if (newValue == 1) {
            dispatchData(changeContract({contractGridVisible: true,royaltiesTabsVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: false, module: 'Royalties',contractGridAPI: "RoyalAbstracts"}));

        }
        if (newValue == 2) {
            dispatchData(changeContract({contractGridVisible: true,royaltiesTabsVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: false, contractSearchVisible: false,
                participationsTabsVisible: false, module: 'Royalties',contractGridAPI: "RoyalBands"}));

        }
        if (newValue == 3) {
            dispatchData(changeContract({contractGridVisible: false,royaltiesTabsVisible: true,
                contractDrilldownVisible: false, contractConfigVisible: true, contractSearchVisible: true,
                participationsTabsVisible: false, module: 'Royalties',contractGridAPI: "RoyalLicenses"}));

        };
        if (newValue == 4) {
            dispatchData(changeContract({contractGridVisible: false,royaltiesTabsVisible: false,
                contractDrilldownVisible: false, participationsTabsVisible: false,contractConfigVisible: true,
                contractSearchVisible: false, module: 'Royalties'}));
            dispatchData(changeContract({contractGridAPI: "RoyalPre"}));
        };
    }


    return (
        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={value} defaultValue={"Standard Contracts"}
                  onChange={handleChange} centered

            >
                <Tab label="Standard Contracts"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                <Tab label="Abstracts"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                <Tab label="Bands"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
                <Tab label="License Contracts"                      sx={{
                    mx: 4,
                    fontSize: '1.2rem',
                    fontWeight: 500,
                    // textTransform: 'none'   // optional: prevents ALL CAPS
                }}/>
                <Tab label="Configurations"
                     sx={{
                         mx: 4,
                         fontSize: '1.2rem',
                         fontWeight: 500,
                         // textTransform: 'none'   // optional: prevents ALL CAPS
                     }}/>
            </Tabs>
        </Box>
    );
}
